<template>
    <div>
        <div class="picture" >
            <img :src="'https://www.mondialrelay.fr/ww2/img/dynamique/pr.aspx?id=' + computeImageId(parcelshop.Numero, parcelshop.Adresse.Pays.Code)">
        </div>
        <div class="unavailability" v-if="parcelshop.unavailability">
            {{$t('parcelshopPicker.parcelshopDetails.unavailability', { 'from':$d(parcelshop.unavailability.from), 'to':$d(parcelshop.unavailability.to) })}}
        </div>
        <div class="table-horaire container-fluid">
            <div class="row horaire-tab" v-for="(horaire,index) in parcelshop.Horaires" :key="index">
                <div class="col-xs-4 days">{{$t(`parcelshopPicker.parcelshopDetails.weekDays[${horaire.JourSemaine}]`)}}</div>
                <div class="col-xs-4 first-slot text-center">{{computeOpeningTimes(horaire.HeureOuvertureAM, horaire.HeureFermetureAM) || $t(`parcelshopPicker.parcelshopDetails.closed`) }}</div>
                <div class="col-xs-4 second-slot text-center">{{computeOpeningTimes(horaire.HeureOuverturePM, horaire.HeureFermeturePM)}}</div>
            </div>
        </div>
        <div v-if=" parcelshop.Services.length" class="services">
            <p class="title-info"><strong>{{$t("parcelshopPicker.parcelshopDetails.availableServices")}}</strong></p>
            <div v-for="(service, index) in parcelshop.Services" :key="index" class="service-list">
                <span v-if="service.Code == 'PRINT'" class="dot">
                    {{$t('parcelshopPicker.parcelshopDetails.ServicePrintInStore')}}
                </span>
                <span v-else class="dot">{{ service.Libelle }}</span>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapState } from "vuex";


export default {
    props: {
        parcelshop: {
            type: Object,
            required: true,
        },
    },
    methods: {
        computeImageId: function(id, countryCode){
            let formatedId = id.toString();

            while (formatedId.length < 6) {
                formatedId = '0' + formatedId
            } 

            return countryCode + formatedId
        },
        computeOpeningTimes: function(open, close){
            if(open && close){
                const openHours = open.split(':')[0]
                const openMinutes = open.split(':')[1]

                const closeHours = close.split(':')[0]
                const closeMinutes = close.split(':')[1]

                const openTime = `${openHours}h${openMinutes}`
                const closeTime = `${closeHours}h${closeMinutes}`

                // TOASK...localisation?
                return `${openTime} - ${closeTime}`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.picture{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
}

.table-horaire > div:nth-of-type(odd) {
    background-color: #eef0f3;
}

.table-horaire > div {
    padding: 5px 15px;

    .days {
        font-weight: bold;
    }
}

.services {
    margin-top: 20px;
    text-align: left;
    padding-left: 10px;
    padding-bottom: 10px;
}

.first-slot {
    white-space: nowrap;
    margin-left: 4rem;
}

.first-slot, .second-slot {
    font-weight: normal;
    padding-left: 0!important;
    padding-right: 0!important;
}
.unavailability {
    padding: 15px 5px 15px 15px;
}

.horaire-tab {
    display: flex;
}

.card-btn {
    background-color: #4dc1be;
    color: #ffffff;
    margin: 3rem 0 1rem;
  }
  .card-btn:hover {
    background-color: #ff5c84;
  }

  @media (min-width: 767.98px) {
    .card-btn {
      display: none;
    }
  }
</style>